import { NetworkBridge, type NetworkInfo } from '@/bridge/network.bridge';

export class NetworkInfoLocalService {
  static async getNetworkInfo(): Promise<NetworkInfo> {
    return NetworkBridge.getNetworkInfo();
  }
}
